import { module } from "angular";
import { LogoAnimationComponent } from "./LogoAnimationComponent";

module("mmGui").component("irLogoAnimation", new LogoAnimationComponent());
